import { Box, VStack } from '@chakra-ui/react'
import { NodeProps, Position } from '@xyflow/react'
import React, { useMemo } from 'react'

import { AiAgentV1NodeData } from '../../converters/shared/reactFlowTypes'
import { useSwitchboardT } from '../../types'
import { text } from '../../utils/text'
import { AiAgentSelector } from '../core'
import { BaseNode, nodePropsAreEqual } from './BaseNode'
import { useAiAgentV1Node } from './hooks/useAiAgentV1Node'

export interface AiAgentV1NodeProps extends NodeProps {
  onDelete?: () => void
  onDeleteNode?: (nodeId: string) => void
  showDeleteButton?: boolean
}

const AiAgentV1NodeComponent: React.FC<AiAgentV1NodeProps> = ({
  id,
  data,
  onDelete,
  onDeleteNode,
  showDeleteButton,
}) => {
  const nodeData = data as AiAgentV1NodeData & Record<string, unknown>
  const { agentId, handleAgentSelect, hasData } = useAiAgentV1Node(id, nodeData)
  const t = useSwitchboardT()

  const additionalHandles = useMemo(
    () => [
      {
        id: 'onError',
        position: Position.Right as Position,
        style: {
          top: 'calc(100%)',
        } as React.CSSProperties,
        label: text(t, 'switchboard.nodes.aiAgent.onError', 'On Error'),
      },
    ],
    [t],
  )

  return (
    <BaseNode
      label={text(t, 'switchboard.nodeLabels.ai_agent_v1', 'AI Agent')}
      showPlaceholder={!hasData}
      onDelete={onDelete}
      onDeleteNode={onDeleteNode}
      id={id}
      showDeleteButton={showDeleteButton}
      sourceHandlePosition={null} // Hide main output — call processing ends on hangup; only On Error is actionable
      additionalSourceHandles={additionalHandles}
    >
      <VStack align="stretch" gap={2}>
        <Box>
          <AiAgentSelector value={agentId} onChange={handleAgentSelect} t={t} />
        </Box>
      </VStack>
    </BaseNode>
  )
}

export const AiAgentV1Node = React.memo(
  AiAgentV1NodeComponent,
  nodePropsAreEqual,
)
